import React from 'react'
import AppDetails from "./appdetails";
import m1 from "../../assets/layout/m1.png";
import m2 from "../../assets/layout/m2.png";
import m3 from "../../assets/layout/m3.png";
import m4 from "../../assets/layout/m4.png";
import m5 from "../../assets/layout/m5.png";
import m6 from "../../assets/layout/m6.png";
import mobilescreen from "../../assets/layout/mobilescreen.png"
import LazyImg from '../lazyimg';

const leftContent = [
    {
        icon : m1,
        heading: "Instant & Convenient",
        content:  "Ouja Helps You save Time by Getting Stuff Done for You. Super Quick, the Best in Your City!"
    },
    {
        icon : m2,
        heading: "No Distance Limits",
        content:  "Our Driver Will Pick You or Your Products and Drop You or Deliver Your Products at Your Destination, No Problem Wherever You Are in Chennai!"
    },
    {
        icon : m3,
        heading: "Exciting Offers - Anywhere in Chennai",
        content:  "Our Services Are Available in Chennai and You Can Make Use of the Several Exciting Offers That Ouja Is Offering."
    }
];

const rightContent = [
    {
        icon : m4,
        heading: "Fast Delivery",
        content:  "Our Delivery Executives Are at Your Service, Anytime!"
    },
    {
        icon : m5,
        heading: "Track Live Orders",
        content:  "We Follow Several Advanced Procedures, Which Helps You Easily Track Your Live Orders Easily."
    },
    {
        icon : m6,
        heading: "Chat to Customize",
        content:  "You Can Chat with Us to Make An Enquiry or to Clear Your Concerns!"
    }
];

const MobileDetails = () => {
    return (
        <div className="container mobile-screen m-t-40">
            <div className="row">
                <div className="col-md-4 p-0">
                    <div className="flex-between flex-column mobile-screen m-t-40 p-t-10">
                    {
                        leftContent.map((detail, index) =>
                            <AppDetails {...detail} key={detail.heading + index}/>
                        )
                    }
                    </div>
                </div>
                <div className="col-md-4 hidden-xs">
                    <LazyImg className="mobilescreen-img" src={mobilescreen} alt="ouja mobile screen" />
                </div>
                <div className="col-md-4 p-0">
                    <div className="flex-between flex-column mobile-screen m-t-40 p-t-10">
                        { rightContent.map((detail, index) =>
                            <AppDetails imgLeft {...detail} key={detail.heading + index}/>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MobileDetails
